import { Injectable } from '@angular/core';
import { getCurrentProductType } from '@shared/extensions/extensions';
import { ContratTransferableFourgous, GetPolicesResponse2, Police3 } from '../MIF.Subscription.Parrot';
import { ParrotService } from './parrot.service';

@Injectable({
  providedIn: 'root'
})
export class WsPolicesService {
  private transferableContracts?: Promise<ContratTransferableFourgousExtended[]>;

  constructor(private parrotService: ParrotService) {}

  public getContratsTransferablesFourgousRequest(): Promise<ContratTransferableFourgousExtended[]> {
    if (!this.transferableContracts) {
      this.transferableContracts = this.parrotService
        .getTransferableContracts(getCurrentProductType())
        .then(transferableContracts => this.mapTransferableContracts(transferableContracts))
        .catch(error => {
          this.transferableContracts = undefined;
          throw error;
        });
    }

    return this.transferableContracts;
  }

  private mapTransferableContracts(transferableContracts: {
    contratTransferableFourgous?: ContratTransferableFourgous[];
  }): ContratTransferableFourgousExtended[] {
    return (transferableContracts.contratTransferableFourgous ?? [])
      .filter((item: ContratTransferableFourgous) => {
        return item.numeroContrat;
      })
      .map((item: ContratTransferableFourgous) => {
        const contract = new ContratTransferableFourgousExtended({
          numeroContrat: item.numeroContrat,
          libelleContrat: item.libelleContrat,
          dateEffet: item.dateEffet,
          valeurRachat: item.valeurRachat
        });

        contract.libelleContratExtended = `Contrat n°${item.numeroContrat} - ${item.libelleContrat}`;
        return contract;
      });
  }

  public async getPolicyByContractNumber(contractNumber: number): Promise<GetPolicesResponse2> {
    const policyContributions = await this.parrotService.getPolicyByContractNumber(contractNumber);

    return new GetPolicesResponse2({
      police: policyContributions.map(
        policyContribution =>
          new Police3({
            numeroContrat: contractNumber,
            cotisation: policyContribution.contribution
          })
      )
    });
  }
}

export class ContratTransferableFourgousExtended extends ContratTransferableFourgous {
  libelleContratExtended!: string;
}
